<template>
    <div>
        <loading :active.sync="loadingContent" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a href="Javascript:;" class="headerButton" @click="$router.go(-1)">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Kebijakan Privasi</div>
        </div>
        <div id="appCapsule">
            <div class="section inset m-1">
                <privacy-policy></privacy-policy>
            </div>
            <!-- <div class="section inset mt-2">
                <div class="wide-block pt-2 pb-2">
                    <p>Sebagai penyedia layanan produk digital, kami {{ VUE_ENV.VUE_APP_NAME }} sangat menjunjung tinggi privasi customer/member. Hal ini karena informasi pribadi merupakan hal yang sangat krusial dan tidak boleh diketahui siapapun. Berikut akan kami jelaskan mengenai informasi apa saja yang kami terima dan kami kumpulkan pada saat Anda mengunjungi situs {{ VUE_ENV.VUE_APP_NAME }} atau menggunakan Aplikasi {{ VUE_ENV.VUE_APP_NAME }}. Serta, tentang bagaimana kami menyimpan dan menjaga informasi tersebut. Kami tegaskan bahwa kami tidak akan pernah memberikan informasi tersebut kepada siapapun.</p>
                    <div>
                        <h3>Informasi Yang Dikumpulkan Oleh {{ VUE_ENV.VUE_APP_NAME }}</h3>
                        <p>Seperti situs dan aplikasi lain pada umumnya, kami mengumpulkan dan menggunakan data yang terdapat pada file log. Informasi yang terdapat pada file log termasuk alamat IP (Internet Protocol) Anda, ISP (Internet Service Provider), browser yang Anda gunakan, perangkat yang digunakan, waktu pada saat Anda berkunjung serta halaman mana saja yang Anda buka selama berkunjung di {{ VUE_ENV.VUE_APP_NAME }}. Jika Anda login melalui aplikasi, kami juga mengumpulkan informasi yang kami simpan di Akun {{ VUE_ENV.VUE_APP_NAME }} Anda, yang kami anggap sebagai informasi pribadi.</p>
                    </div>
                    <div>
                        <h3>Kami Menggunakan Data Untuk Membangun Layanan Yang Lebih Baik</h3>
                        <p>Kami menggunakan informasi Anda untuk memberikan layanan kami, mempertahankan & meningkatkan layanan kami, mengembangkan layanan baru, mengukur performa, berkomunikasi dengan Anda dan melindungi Akun {{ VUE_ENV.VUE_APP_NAME }} Anda. Data yang dikumpulkan oleh situs dan aplikasi kami tidak akan di sebarluaskan ke pihak manapun dan murni akan di gunakan secara profesional oleh {{ VUE_ENV.VUE_APP_NAME }}.</p>
                    </div>
                    <div>
                        <h3>Mengelola, Meninjau, Dan Memperbarui Informasi Anda</h3>
                        <p>Saat login, Anda dapat meninjau dan memperbarui informasi yang telah dikumpulkan dengan melakukan perubahan di aplikasi {{ VUE_ENV.VUE_APP_NAME }}.</p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            loadingContent: true
        }
    },
    created(){
        setTimeout(() => this.loadingContent = false, 500)
    },
    computed:{
        ...mapState(['VUE_ENV'])
    }
}
</script>